import { fromJS } from 'immutable';
import {
  START_LOADING,
  GET_AVAILABILITY_SUCCESS,
  GET_AVAILABILITY_FAIL,
  SWAP_PREV_AVAILABILITY,
  SWAP_NEXT_AVAILABILITY,
  SET_INITIAL_STATE,
  CHANGE_PLANNER_MODE,
  GET_APPOINTMENTS_FAIL,
  GET_APPOINTMENTS_SUCCESS,
  REMOVE_APPOINTMENT_SUCCESS,
  REMOVE_APPOINTMENT_FAIL,
  UPDATE_APPOINTMENT_FAIL,
  UPDATE_APPOINTMENT_SUCCESS,
} from './actions';
import { GENERIC_ERROR } from 'constants/errors.constants';

const initialState = fromJS({
  prevAvailability: null,
  currentAvailability: null,
  nextAvailability: null,
  initialPrevAvailability: null,
  initialCurrentAvailability: null,
  initialNextAvailability: null,
  vehicles: null,
  isPlannerMode: true,
  loading: false,
  errors: {},
  appointments: null,
});

function plannerReducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING:
      return state.set('loading', true);
    case GET_AVAILABILITY_SUCCESS:
      return state
        .set('loading', false)
        .set('prevAvailability', action.payload.availability.slice(0, 7))
        .set('currentAvailability', action.payload.availability.slice(7, 14))
        .set('nextAvailability', action.payload.availability.slice(14, 21))
        .set('initialPrevAvailability', action.payload.availability.slice(0, 7))
        .set('initialCurrentAvailability', action.payload.availability.slice(7, 14))
        .set('initialNextAvailability', action.payload.availability.slice(14, 21))
        .set('vehicles', action.payload.vehicles);
    case SWAP_PREV_AVAILABILITY:
      return state.set('currentAvailability', state.get('prevAvailability'));
    case SWAP_NEXT_AVAILABILITY:
      return state.set('currentAvailability', state.get('nextAvailability'));
    case SET_INITIAL_STATE:
      return state
        .set('prevAvailability', state.get('initialPrevAvailability'))
        .set('currentAvailability', state.get('initialCurrentAvailability'))
        .set('nextAvailability', state.get('initialNextAvailability'));
    case CHANGE_PLANNER_MODE:
      return state.set('isPlannerMode', !state.get('isPlannerMode'));
    case GET_APPOINTMENTS_SUCCESS:
      return state.set('loading', false).set('appointments', action.payload.appointments);
    case REMOVE_APPOINTMENT_SUCCESS: {
      const idToRemove = action.payload.id;
      return state.set('loading', false).set(
        'appointments',
        (state.get('appointments') || []).map((day) => ({
          ...day,
          appointments: day.appointments.filter((appt) => appt.id !== idToRemove),
        }))
      );
    }
    case UPDATE_APPOINTMENT_SUCCESS: {
      const updatedAppointment = action.payload.appointment;
      return state.set('loading', false).set(
        'appointments',
        (state.get('appointments') || []).map((day) => ({
          ...day,
          appointments: day.appointments.filter((appt) => appt.id !== updatedAppointment.id),
        }))
      );
    }
    case GET_AVAILABILITY_FAIL:
    case GET_APPOINTMENTS_FAIL:
    case REMOVE_APPOINTMENT_FAIL:
    case UPDATE_APPOINTMENT_FAIL:
      return state.set('loading', false).set('errors', fromJS(action.payload.errors || GENERIC_ERROR));
    default:
      return state;
  }
}

export default plannerReducer;
